import { default as React } from "react";

export default function FourOhFour() {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center"
    }}>
      Sidan finns inte
      
    </div>
  );
}
